import { CepInfoData } from 'src/services/frete'

export function addressFormatted({ rua, cidade, estado }: CepInfoData) {
  if (rua === '') {
    return `${cidade} - ${estado}`
  }
  return `${rua} - ${cidade} - ${estado}`
}
